import { Action } from "@ngrx/store";

import { ProcessingEvent } from "../model/processing/processing-event.model";

/* tslint:disable max-classes-per-file */
export const DATA_UPDATED = "DATA_UPDATED";


export class DataUpdated implements Action {
  public readonly type = DATA_UPDATED;
  constructor(public payload: ProcessingEvent) {}
}
export type ProcessingActions = DataUpdated;
/* tslint:enable max-classes-per-file */
